<!-- //  计算叠层结构 -->
<template>
  <div v-loading="loading" class="impedance__content">
    <!-- 计算叠层结构参数 -->
    <div class="impedance__params">
      <!-- 板子基本信息 -->
      <p class="impedance__title">{{ LANG.boardBase.en }}</p>
      <ul class="impedance__params__order">
        <li v-for="key in Object.keys(order)" :key="key">
          <span>{{ orderItems[key].label }}</span>
          <span class="default">{{ orderItems[key].formatter ? orderItems[key].formatter(order[key]) : order[key] }}</span>
        </li>
      </ul>

      <!-- Stack up  推荐叠层-->
      <div class="impedance__params__stackup">
        <p>Stack up</p>

        <el-radio-group v-model="pressing" @input="handlePressingCheck" class="nextpcb-radio-group">
          <template v-for="(item, index) in pressingList">
            <el-radio :key="index" :label="item.real" border>{{ item.word }}</el-radio>
          </template>
        </el-radio-group>
      </div>

      <!-- 操作按钮 -->
      <template v-if="!isShowRecomputeBtn">
        <!-- 选择叠层结构表格 -->
        <el-table class="impedance__params__list impedance-table" border :data="params">
          <el-table-column :label="LANG.demand.en + ''" width="150">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                :placeholder="LANG['请输入'].en"
                :precision="0"
                :min="40"
                :max="130"
                :controls="false"
                :class="getEmptyClass(scope.$index, 'demand')"
                :value="params[scope.$index].demand || undefined"
                @input="val => params[scope.$index].demand = val"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.impLayer.en" width="100">
            <template slot-scope="scope">
              <el-select
                size="mini"
                popper-class="impedance__params__select"
                :placeholder="LANG['请选择'].en"
                :value="params[scope.$index].layer"
                @input="val => handleLayerInput(scope.$index, val)"
              >
                <el-option 
                  v-for="item in blayerOptions" 
                  :key="item" 
                  :value="item" 
                  :label="item"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.modeCn.en">
            <template slot-scope="scope">
              <el-select
                size="mini"
                popper-class="impedance__params__select"
                :placeholder="LANG['请选择'].en"
                :value="params[scope.$index].mode"
                @input="val => params[scope.$index].mode = val"
              >
                <el-option 
                  v-for="(label, value) in modeOptions" 
                  :key="value" 
                  :value="Number(value)" 
                  :label="label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.top.en" width="100">
            <template slot-scope="scope">
              <template v-if="getTopValue(scope.$index, scope.row) !== '/'">
                <el-select
                  size="mini"
                  popper-class="impedance__params__select"
                  :placeholder="LANG['请选择'].en"
                  :disabled="getTopValue(scope.$index, scope.row) === '/'"
                  :value="getTopValue(scope.$index, scope.row)"
                  @input="val => params[scope.$index].top = val"
                >
                  <el-option 
                    v-for="item in getTopOptions(scope.row)" 
                    :key="item" 
                    :value="item" 
                    :label="item"
                  ></el-option>
                </el-select>
              </template>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.bot.en" width="100">
            <template slot-scope="scope">
              <template v-if="getBotValue(scope.$index, scope.row) !== '/'">
                <el-select
                  size="mini"
                  popper-class="impedance__params__select"
                  :placeholder="LANG['请选择'].en"
                  :value="getBotValue(scope.$index, scope.row)"
                  @input="val => params[scope.$index].bot = val"
                >
                  <el-option 
                    v-for="item in getBotOptions(scope.row)" 
                    :key="item" 
                    :value="item" 
                    :label="item"
                  ></el-option>
                </el-select>
              </template>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.originalLineWidth.en">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                :placeholder="LANG['请输入'].en"
                :precision="2"
                :min="3"
                :max="80"
                :controls="false"
                :class="getEmptyClass(scope.$index, 'original_line_width')"
                :value="params[scope.$index].original_line_width || undefined"
                @input="val => params[scope.$index].original_line_width = val"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.originalLineSpace.en">
            <template slot-scope="scope">
              <template v-if="getLineSpaceValue(scope.$index, scope.row) !== '/'">
                <el-input-number
                  size="mini"
                  :placeholder="LANG['请输入'].en"
                  :precision="2"
                  :min="3.8"
                  :max="20"
                  :controls="false"
                  :class="getEmptyClass(scope.$index, 'original_line_space')"
                  :value="getLineSpaceValue(scope.$index, scope.row) || undefined"
                  @input="val => params[scope.$index].original_line_space = val"
                ></el-input-number>
              </template>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column :label="LANG.originalCopperSpace.en">
            <template slot-scope="scope">
              <template v-if="getCopperSpaceValue(scope.$index, scope.row) !== '/'">
                <el-input-number
                  size="mini"
                  :placeholder="LANG['请输入'].en"
                  :precision="2"
                  :min="4"
                  :max="50"
                  :controls="false"
                  :class="getEmptyClass(scope.$index, 'original_copper_space')"
                  :value="getCopperSpaceValue(scope.$index, scope.row) || undefined"
                  @input="val => params[scope.$index].original_copper_space = val"
                ></el-input-number>
              </template>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column label="" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleAdd(scope.$index)">{{ LANG.add.en }}</el-button>
              <el-button type="text" size="mini" :disabled="disabledDelBtn" @click="handleDel(scope.$index)">{{ LANG.delete.en }}</el-button>
              <el-button type="text" size="mini" @click="handleCopy(scope.$index)">{{ LANG.copy.en }}</el-button>
              <!-- <el-radio
                :label="scope.$index"
                :value="currentParamsIndex"
                @input="val => currentParamsIndex = val"
              ></el-radio> -->
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>

    <!-- 叠层结构列表 -->
    <div class="impedance__list">
      <p class="impedance__title">{{ LANG['华秋叠层结构'].en }}</p>
      <template v-if="list.length > 0">
        <div 
          v-for="(item, index) in list" 
          :key="index" 
          :class="['impedance__list__item', currentPressingWithPP === item.pressing_with_pp ? 'is-checked' : '']"
          :id="item.pressing_with_pp"
        >
          <div class="impedance__list__item_title">
            <p>
              <el-checkbox v-model="item.isChecked" @change="(val) => handleCheckStackup(val, item)" style="margin-right: 10px;"></el-checkbox>
              {{ `${LANG['结构'].en}${index + 1}：NextPCB ${item.pressing_with_pp} ` }}({{ item.is_free == 1 ? 'Free': 'Charging fee' }})
            </p>
            <template v-if="hasRedColorItem(item.impedance).length > 0">
              <span class="impedance__list__item__tips">
                {{ LANG['此结构计算结果不符合制作要求'].en }}：{{ hasRedColorItem(item.impedance).join('、') }}
              </span>
            </template>
          </div>

          <div>
            <!-- 阻抗表 -->
            <impedance-table :list="item.impedance"></impedance-table>
            <!-- 压合结构 -->
            <impedance-stack :list="item.stack"></impedance-stack>
          </div>
        </div>
      </template>
      <div v-else class="impedance__list__noData">{{ LANG['暂无数据'].en }}</div>
    </div>
  </div>
</template>

<script>
import { LANG } from './lang'
import ImpedanceStack from './impedance-stack.vue'
import ImpedanceTable from './impedance-table'
import TextTip from './text-tip.vue'

export default {
  components: {
    ImpedanceStack,
    ImpedanceTable,
    TextTip
  },

  props: {
    // dialog: 计价页 阻抗匹配叠层计算弹框 page: 阻抗匹配叠层工具页面
    pageType: {
      type: String,
      default: 'dialog'
    },
    orderParams: {
      type: Object,
      default: () => ({})
    },
    computedData: {
      type: Object,
      default: null
    },
    // 已选的推荐结构编号
    value: {
      type: String,
      default: ''
    },
    pressingList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    // 推荐结构计算默认参数
    const PARAMS_ITEM = {
      demand: undefined, // 要求阻抗（ohm）
      layer: 'L1', // 阻抗层
      mode: 0, // 阻抗模式 0-单端 1-差分 2-共面单端 3-共面差分
      top: '', // 上参考层
      bot: '', // 下参考层
      original_line_width: undefined, // 原始线宽
      original_line_space: '', // 原始线距
      original_copper_space: '', // 原始到铜距离
    }

    return {
      LANG,
      loading: false,
      isShowRecomputeBtn: false, // 是否显示重新计算按钮
      textTips: LANG.textTips.en,
      order: {
        blayer: 4, // 层数
        bheight: 1.6, // 板厚
        copper: 1, // 外层铜厚
        insidecopper: 0.5, // 内层铜厚
        hdi: 0, // HDI(盲埋孔) 1:有，0:无
      },
      orderItems: {
        blayer: { label: LANG.layer.en, options: [2, 4, 6, 8, 10] }, // 层数
        bheight: {
          label: LANG.bheight.en,
          options: [0.6, 0.8, 1.0, 1.2, 1.6, 2.0, 2.5]
        }, // 板厚
        copper: { label: LANG.outerCopper.en, options: [], formatter: val => `${val}oz` }, // 外层铜厚
        insidecopper: { label: LANG.innerCopper.en, options: [0.5, 1], formatter: val => `${val}oz` }, // 内层铜厚
        hdi: { label: LANG.blind.en, options: [0, 1], formatter: val => ({ 0: 'No', 1: 'Yes', 2: 'Yes', 3: 'Yes' }[val]) }, // HDI(盲埋孔) 1:有，0:无
      },
      currentParamsIndex: '', // 推荐结构参数当前选中的索引
      paramsItem: Object.freeze(PARAMS_ITEM),
      params: [], // 推荐结构参数
      emptyParams: [], // 计算时校验为空的字段
      addRows: '', // 要添加的参数行数
      currentPressingWithPP: this.value, // 当前选中的推荐结构编号
      startWatchParams: false, // 开始监听参数变化
      list: [], // 叠层结构列表
      modeOptions: { 
        0: LANG['单端'].en, 
        1: LANG['差分'].en, 
        2: LANG['共面单端'].en, 
        3: LANG['共面差分'].en 
      },
      pressing: this.value
    }
  },

  computed: {
    isDialog() {
      return this.pageType === 'dialog'
    },
    // 禁用删除按钮
    disabledDelBtn() {
      const { params } = this
      return params.length === 1
    },
    // 禁用复制按钮
    disabledCopyBtn() {
      const { currentParamsIndex } = this
      return !currentParamsIndex && currentParamsIndex !== 0
    },
    // 阻抗层选项：[L1, L2, ..., L(当前板子层数)]
    blayerOptions() {
      const blayer = this.order.blayer
      return Array.from({ length: blayer }, (x, index) => `L${index + 1}`)
    },
  },

  watch: {
    value(newVal) {
      this.currentPressingWithPP = newVal
    },
    orderParams(newVal) {
      // PCB计价页 阻抗匹配叠层计算弹框
      this.order = Object.assign(this.order, newVal)
    },
    params: {
      handler: function (newVal, oldVal) {
        this.$nextTick(() => {
          // 当推荐结构列表有数据且参数改变时，重置推荐结构列表数据
          const { startWatchParams, list } = this
          if (
            startWatchParams &&
            list.length > 0
          ) {
            this.handleReset(newVal)
          }
        })
      },
      deep: true
    },
    pressing(newVal) {
      this.$emit('syncPressing', newVal)
    }
  },

  created() {
    const { isDialog, orderParams, order, paramsItem, orderItems, computedData, currentPressingWithPP } = this
    if (isDialog) {
      // PCB计价页 阻抗匹配叠层计算弹框
      this.order = Object.assign(order, orderParams)
      const { list = [], params = [] } = computedData || {}
      this.params = params && params.length > 0 ? [...params] : [{ ...paramsItem }]

      if (list.length > 0) {
        this.list = list
        this.isShowRecomputeBtn = true
      } else {
        this.list = [...list]
      }
    } else {
      // 当有传板子信息过来时，使用传过来的值，否则使用默认值
      Object.entries(order).forEach(([key, defaultVal]) => {
        // 外层铜厚：1oz不可修改
        if (key !== 'copper') {
          const val = 0 //getUrlParam(key)
          this.order[key] = val && orderItems[key].options.includes(Number(val)) ? Number(val) : defaultVal
        }
      })
      // 默认参数
      this.params = [{ ...paramsItem }]
    }
    // 防止一打开页面，就触发 params watch 导致重置已有的推荐结构数据
    setTimeout(() => {
      this.startWatchParams = true
    }, 100)
  },

  methods: {
    // 添加
    handleAdd() {
      const rows = Number(this.addRows)
      // 一次最多添加50条
      this.addRows = isNaN(rows) || rows <= 0 ? 1 : Math.min(rows, 50)
      const params = Array.from({ length: this.addRows }).map(() => ({ ...this.paramsItem }))
      this.params.push(...params)
    },
    // 删除
    handleDel(index) {
      if (!index && index !== 0) return
      this.params.splice(index, 1)
      this.currentParamsIndex = ''
    },
    // 复制
    handleCopy(index) {
      if (!index && index !== 0) return
      this.params.push(Object.assign({}, this.params[index]))
    },
    // 对计算字段进行校验
    handleValidate() {
      // 需要对 要求阻抗（ohm）、线宽、线距、到铜距离 做必填校验
      const NOT_EMPTY_FIELDS = ['demand', 'original_line_width', 'original_line_space', 'original_copper_space']
      const emptyParams = []
      this.params.forEach(item => {
        emptyParams.push(NOT_EMPTY_FIELDS.filter(key => !item[key] && item[key] != 0))
      })
      this.emptyParams = emptyParams
      if (emptyParams.some(item => item.length > 0)) return

      this.handleComputed()
    },
    // 计算
    handleComputed() {
      const { order, params } = this

      // 重置已有选项
      this.list = []
      this.loading = true
      const that = this
      const sendData =  { order, pressing: params }
      this.$emit('isLoading', this.loading)
      this.$http.post(this.$api.quoteRecommendPressing, sendData, { headers: { 'Content-Type': 'application/json' } }).then(res => {
        that.loading = false
        if (!res) return

        const { status, data, msg } = res
        if (status == 1) {
          const { pressing_result, pressing_computer_id } = data
          // 推荐结构列表
          that.list = pressing_result || []
          that.list.forEach(item => {
            if (item.pressing_with_pp == this.pressing) {
              this.$set(item, 'isChecked', true)
            } else {
              this.$set(item, 'isChecked', false)
            }
            item.impedance.forEach(item1 => {
              item1.mode_cn = this.translateChineseToEnglish(item1.mode_cn)
            })

            item.stack.forEach(item2 => {
              item2.material = this.translateChineseToEnglish(item2.material)
              item2.material_name = this.translateChineseToEnglish(item2.material_name)
              item2.material_properties = this.translateChineseToEnglish(item2.material_properties)
            })
          })
          that.handleEmitCompute({ pressing_computer_id, list: pressing_result, params })
        } else {
          that.$alert.msg(msg)
        }
      }).finally(() => {
        that.loading = false
        this.$emit('isLoading', this.loading)
      })
    },
    // 获取已确认的参数和推荐结构列表
    handleCachePrevConfirmData() {
      this.prevConfirmData = this.prevComputedData
    },
    // 重置叠层结构参数
    handleReset(params) {
      this.params = params ? [...params] : [{ ...this.paramsItem }]
      this.list = []
      this.handleEmitPressingWithPP('')
      // this.handleEmitCompute(null)
    },
    // 当前已选推荐结构改变
    handleEmitPressingWithPP(val) {
      this.$emit('input', val)
    },
    // 当前计算改变
    handleEmitCompute(val) {
      this.$emit('compute', val)
    },
    
    handleOrderInput(key, val) {
      this.order[key] = val
      this.handleReset(this.params)
    },
    
    handleLayerInput(index, val) {
      this.params[index] = Object.assign(this.params[index], { layer: val, top: '', bot: '' })
    },
    
    getEmptyClass(index, field) {
      const emptyParams = this.emptyParams[index]
      return emptyParams && emptyParams.includes(field) ? 'error' : ''
    },
    
    getTopOptions(row) {
      const blayerOptions = this.blayerOptions
      const optionIndex = blayerOptions.findIndex(i => i === row.layer)
      // 上参考层选项：[L1, L2, ..., (当前阻抗层)]
      return blayerOptions.filter((i, index) => index < optionIndex)
    },
    
    getTopValue(index, row) {
      const options = this.getTopOptions(row)
      this.params[index].top = options.length > 0
        ? row.top && options.includes(row.top) ? row.top : options[options.length - 1] // 当阻抗层改变时，上参考层默认为阻抗层上一层，当上参考层改变时，为选中的值
        : '/'
      return this.params[index].top
    },
    
    getBotOptions(row) {
      const blayerOptions = this.blayerOptions
      const optionIndex = blayerOptions.findIndex(i => i === row.layer)
      // 下参考层：[(当前阻抗层), ..., (当前板子层数)]
      return blayerOptions.filter((i, index) => index > optionIndex)
    },
    
    getBotValue(index, row) {
      const options = this.getBotOptions(row)
      this.params[index].bot = options.length > 0
        ? row.bot && options.includes(row.bot) ? row.bot : options[0] // 当阻抗层改变时，下参考层默认为阻抗层下一层，当下参考层改变时，为选中的值
        : '/'
      return this.params[index].bot
    },
    
    getLineSpaceValue(index, row) {
      const { mode, original_line_space } = row
      // 当阻抗模式为差分、共面差分时可输入
      this.params[index].original_line_space = [1, 3].includes(mode)
        ? original_line_space && original_line_space !== '/' ? original_line_space : undefined
        : '/'
      return this.params[index].original_line_space
    },
    
    getCopperSpaceValue(index, row) {
      const { mode, original_copper_space } = row
      // 当阻抗模式为共面单端、共面差分时可输入
      this.params[index].original_copper_space = [2, 3].includes(mode)
        ? original_copper_space && original_copper_space !== '/' ? original_copper_space : undefined
        : '/'
      return this.params[index].original_copper_space
    },
    
    // 线宽、线距、到铜距离、计算结果 有标红的项
    hasRedColorItem(impedance) {
      const limits = { line_width: 3, line_space: 3.8, copper_space: 4, result_color: 1 }
      const isRed = item => Object.entries(limits).reduce((keys, [key, limit]) => {
        const value = item[key]
        if ((key === 'result_color' && value === 1) || (!value || (value !== '/' && Number(value) < limit))) {
          keys.push(key)
        }
        return keys
      }, [])
      const redKeys = impedance.reduce((keys, item) => [...keys, ...isRed(item)], [])
      return [...new Set(redKeys)].map(key => ({
        line_width: LANG['线宽小于3mil'].en,
        line_space: LANG['线距小于3.8mil'].en,
        copper_space: LANG['到铜距离小于4mil'].en,
        result_color: LANG['计算结果与阻抗值相差±2ohm'].en
      }[key]))
    },
    translateChineseToEnglish(str) {
      // 使用正则表达式查找中文字符，并使用翻译映射替换
      if(!str) return
      return str.replace(/[\u4e00-\u9fa5]+/g, match => {
          // 查找匹配的翻译
          let translation = LANG[match].en;
          // 如果没有找到翻译，保留原样
          if (!translation) {
              translation = match;
          }
          return translation;
      })
    },
    initCheckIsFalse(currentCheck) {
      this.list.forEach(item => {
        if(item.pressing_with_pp !== currentCheck) {
          this.$set(item, 'isChecked', false)
        }
      })
    },
    handlePressingCheck() {
      this.currentPressingWithPP = this.pressing
      this.list.forEach(item => {
        if(item.pressing_with_pp === this.pressing) {
          this.$set(item, 'isChecked', true)
          this.$tools.domScrollToViewById(this.pressing)
        } else {
          this.$set(item, 'isChecked', false)
        }
      })
    },
    handleCheckStackup(val, item) {

      // 如果用户尝试取消选中，则阻止该操作
      if (!val) {
        // 强制保持选中状态
        this.$set(item, 'isChecked', true);
        return
      }
      
      // 如果是选中操作，则取消其他项的选中状态
      this.list.forEach(listItem => {
        if (listItem.pressing_with_pp !== item.pressing_with_pp) {
          this.$set(listItem, 'isChecked', false);
        }
      })
      
      this.currentPressingWithPP = item.pressing_with_pp;
      this.pressing = item.pressing_with_pp;
    }
  }
}
</script>